import { render } from "./maintenance-history.vue?vue&type=template&id=09bed0cf&ts=true"
import script from "./maintenance-history.vue?vue&type=script&lang=ts"
export * from "./maintenance-history.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__